export default "__VITE_ASSET__oBTMJ92$__"